import SelectBox from "../../common/SelectBox";

const ChartFilter = ({ filters, handleFilterChange, selectedFilters }) => { 
  return filters.map(item => (
    <div key={item.FILTER_NAME}>  
      <p>Select {item.FILTER_NAME}:</p>
      <SelectBox
        selectValue={(value) => handleFilterChange(item.FILTER_NAME, value)} 
        initialValue={selectedFilters[item.FILTER_NAME] || ''} // Controlled by state
        selectObject={{
          label: item.FILTER_NAME, 
          menuItems: item.options.map(option => option.OPTION_NAME)
        }}
      /> 
    </div>
  ));
};

export default ChartFilter;